import * as actionTypes from "./../../Constants/categoryActionTypes";
import API from "./../../Constants/categories/API"
import * as categoryServices from "../../services/categories/index"
import moment from "moment";

export const newCategories = (categoryData, request) => ({
    type: actionTypes.SAVE_EDITS,
    payload: { categoryData: [...categoryData, ...request].sort((a, b) => parseInt(a.cat_Order) - parseInt(b.cat_Order))
    }
})

export function saveEdits (cat, allCategories) {
    return async dispatch => {
        const request = await categoryServices.req.setAllCategories(API.saveAllCategories, cat)
        //return dispatch(newCategories(cat));
        const returnedIds = request.map(elem => elem.category_id);
        const unmodifiedCategories = allCategories.filter((elem) => {
            return !returnedIds.includes(elem.category_id)
        })
        //dispatch(actions.notify("Saved Successfully"));
        return dispatch(newCategories(unmodifiedCategories, request.map((elem) => {
            elem.updated_on = moment(elem.updated_on).format("MM/DD/YY");
            return elem
        })));
    };
}
